// extracted by mini-css-extract-plugin
module.exports = {"drawer":"drawer_2phud","disableClick":"disableClick_1i72w","notificationPageWrapper":"notificationPageWrapper_62wgv","closeIcon":"closeIcon_6z0jh"};